export default {
      id: "anchor-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#anchor",
      toString: function () {
        return this.url;
      }
    }